// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Yaay","sendOtp":"AuthorizeToLogin_sendOtp__1_57l"};